module.exports = __webpack_public_path__ + "img/bonus.67812cea.svg";